// NotificationBell.jsx
import React, { useState, useRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { Link } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

export default function MenuButton({
  notifications = [],
  onItemClick = () => {},
  color = "inherit",
  menuButtonLabel = "Menu",
}) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const useStyles = makeStyles({
    link: {
      cursor: "pointer",
      width: "100%",
      display: "block",
      "&:hover": {
        textDecoration: "none",
        color: "black",
      },
    },
  });

  const classes = useStyles();

  const handleToggle = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) return;
    setOpen(false);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleToggle}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#ddd";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#ddd";
        }}
        style={{ padding: "8px 12px" }}
      >
        <span style={{ fontSize: 12, fontWeight: "bold", color: "#111" }}>
          {menuButtonLabel}
        </span>
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        placement="bottom-end"
        style={{ zIndex: 2000 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps}>
            <Paper style={{ marginTop: 8, minWidth: 260 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={open}>
                  {notifications.length === 0 && (
                    <MenuItem disabled>No hay notificaciones</MenuItem>
                  )}

                  {notifications.map((item, index) => (
                    <MenuItem
                      key={index}
                      onClick={(e) => item.onClick && item.onClick(e)}
                    >
                      <Link
                        href={item.url || "#"}
                        color="inherit"
                        underline="none"
                        className={classes.link}
                        onClick={(e) => item.onClick && item.onClick(e)}
                      >
                        {item.label || item}
                      </Link>
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}
